import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';

import { loginRequest } from '../msal/config';

export const useGetAccessToken = () => {
  const {
    instance,
    accounts: [activeAccount],
  } = useMsal();

  return useCallback(async () => {
    if (!activeAccount) {
      throw await instance.loginRedirect(loginRequest);
    } else {
      try {
        const { accessToken } = await instance.acquireTokenSilent({
          ...loginRequest,
          account: activeAccount,
        });

        return accessToken;
      } catch {
        throw await instance.loginRedirect(loginRequest);
      }
    }
  }, [instance, activeAccount]);
};
